/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ModalHeader } from '@ds';
import { PiDownloadSimpleBold } from 'react-icons/pi';
import { FiZoomIn } from 'react-icons/fi';
import { BiZoomOut } from 'react-icons/bi';
import { MdShare } from 'react-icons/md';
import { downloadMedia } from '@features/components/ClinicalData/utils';
import { ClinicalMediaType } from '@/api/apis/case';

type MediaPreviewHeaderProps = {
  heading: string;
  currentMedia: ClinicalMediaType;
  useDirectPath?: boolean;
  onClose: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  isFromClinicalLog?: boolean;
  onShareClick?: () => void;
};

export const MediaPreviewHeader = ({
  heading,
  currentMedia,
  onClose,
  onZoomIn,
  onZoomOut,
  isFromClinicalLog = false,
  useDirectPath = false,
  onShareClick,
}: MediaPreviewHeaderProps) => {
  return (
    <ModalHeader className="relative shrink-0 px-8 py-5">
      <div className="absolute inset-0 z-0 bg-black opacity-50" />
      <div className="relative z-10 flex w-full items-center justify-between">
        <span className="text-sm font-semibold text-white">{heading}</span>

        <div className="flex flex-row items-center gap-6">
          <div className="flex flex-row items-center gap-2">
            <span aria-label="zoom in" className="cursor-pointer" onClick={onZoomIn}>
              <FiZoomIn size={24} color="white" />
            </span>

            <span aria-label="zoom out" className="cursor-pointer" onClick={onZoomOut}>
              <BiZoomOut size={24} color="white" />
            </span>

            <span
              aria-label="download media"
              className="cursor-pointer"
              onClick={() => downloadMedia(currentMedia.file.path, currentMedia.file.fileName, useDirectPath)}
            >
              <PiDownloadSimpleBold size={24} color="white" />
            </span>

            {onShareClick && isFromClinicalLog && (
              <span
                aria-label="share media"
                className="cursor-pointer"
                onClick={() => {
                  onShareClick();
                  onClose();
                }}
              >
                <MdShare size={24} color="white" />
              </span>
            )}
          </div>

          <span
            onClick={onClose}
            className="flex h-9 w-[120px] cursor-pointer items-center justify-center gap-1 rounded-3xl border border-white text-sm font-semibold text-white transition duration-200 hover:bg-gray-600"
          >
            Close
          </span>
        </div>
      </div>
    </ModalHeader>
  );
};
